import { prop } from 'ramda'

export const playing = prop('playing')
